import api from './api';

export interface LogSendMail {
    id: string;
    email: string;
    subject: string;
    message: string;
    ccEmail: string;
    nameFunctionCall: string;
    statusEmail: string;
    descricaoErro: string;
    ccEmailTela: string[];
    dataDoEnvio: string;
}

export interface SendMail {
    email: string;
    cc: string[];
    id: string;
}


export const getAllLogSendMail = () => api.get<LogSendMail[]>('logs/getAllLogSendMail');
export const postEnviarEmail = (email: SendMail) => {
    return api.post('logs/enviarEmail', email);
}